// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-tabs[data-v-1ef8fa5c]{width:800px}[data-v-1ef8fa5c] .el-badge__content.is-fixed{top:10px!important;right:16px!important}.el-tabs--bottom .el-tabs__item.is-bottom[data-v-1ef8fa5c]:last-child,.el-tabs--bottom .el-tabs__item.is-top[data-v-1ef8fa5c]:last-child,.el-tabs--top .el-tabs__item.is-bottom[data-v-1ef8fa5c]:last-child,[data-v-1ef8fa5c] .el-tabs--top .el-tabs__item.is-top:last-child{padding-right:20px!important}", ""]);
// Exports
module.exports = exports;
